import FloatNumberValidator from "../../../../administration/userManagement/ratesEditor/FloatNumberValidator"
import {MAX_RATE} from "../../../../constants"
import {ShowWarning, UserRatesErrors} from './constants'
import _ from 'underscore'
import {ValidationErrors} from '../../constants'

const floatNumberValidator = new FloatNumberValidator(window.SystemSettings.decimalSeparator)

export const getValidRates = ({
    rates,
    leaveTypesEnabled,
    overtimeEnabled
}) => {

    return rates.filter(rate => isUserRateValid(rate, overtimeEnabled, leaveTypesEnabled))

}

export const mergeUserRates = (oldRates, newRates) => {
    const ratesByDate = {}
    newRates.forEach(rate => ratesByDate[rate.effectiveDate] = rate)
    const result = []
    oldRates.forEach(rate => {
        if (ratesByDate[rate.effectiveDate]) {
            result.push(ratesByDate[rate.effectiveDate])
        } else {
            result.push(rate)
        }
    })
    return result
}

export const isValueEmpty = rate => {
    return rate === undefined || rate === null || rate.length === 0
}

export const isRateEmpty = (rate, overtimeEnabled, leaveTypesEnabled) => {
    return isValueEmpty(rate.regularRate) && (!overtimeEnabled || isValueEmpty(rate.overtimeRate)) && (!leaveTypesEnabled || isLeaveRatesEmpty(rate.leaveRates))
}

export const isLeaveRatesEmpty = (leaveRates) => {
    return !leaveRates || leaveRates.length === 0 || leaveRates.every(leaveRate => isValueEmpty(leaveRate.rate))
}

export const isLeaveRatesValid = (leaveRates) => {
    return leaveRates && leaveRates.every(leaveRate => isRateValid(leaveRate.rate))
}

export const isRateValid = (rate) => {
    return floatNumberValidator.isValidNumber(rate) && floatNumberValidator.parseFloat(rate) < MAX_RATE
}

export const isUserRateValid = (rate, overtimeEnabled, leaveTypesEnabled) => {
    return (rate.effectiveDate !== null) &&
           (!isValueEmpty(rate.regularRate) && isRateValid(rate.regularRate)) &&
           (!overtimeEnabled || (!isValueEmpty(rate.overtimeRate) && isRateValid(rate.overtimeRate))) &&
           (!leaveTypesEnabled || (!isLeaveRatesEmpty(rate.leaveRates) && isLeaveRatesValid(rate.leaveRates)))
}

export const isInitialScheduleValid = (initialSchedule) => {
    return initialSchedule.every(d => d !== null)
}

export const getUserRatesErrors = (rates, overtimeEnabled, leaveTypesEnabled, withWarning, updatingRateIndex, updatingRate) => {
    let isValid = true
    const errors = {}

    const rateByEffectiveDate = _.groupBy(rates.filter(rate => rate.effectiveDate !== null), 'effectiveDate')

    rates.forEach((rate, index) => {
        let error = {}

        const rateEmpty = isRateEmpty(rate, overtimeEnabled, leaveTypesEnabled)

        error[UserRatesErrors.EFFECTIVE_DATE_EMPTY] = !rateEmpty && isValueEmpty(rate.effectiveDate)
        error[ValidationErrors.DUPLICATED_EFFECTIVE_DATE] = rate.effectiveDate !== null && rateByEffectiveDate[rate.effectiveDate].length > 1

        error[UserRatesErrors.REGULAR_RATE_EMPTY] = !rateEmpty && isValueEmpty(rate.regularRate)
        error[UserRatesErrors.REGULAR_RATE_INVALID] = !rateEmpty && !isRateValid(rate.regularRate)

        if (overtimeEnabled) {
            error[UserRatesErrors.OVERTIME_RATE_EMPTY] = !rateEmpty && isValueEmpty(rate.overtimeRate)

            error[UserRatesErrors.OVERTIME_RATE_INVALID] = !rateEmpty && !isRateValid(rate.overtimeRate)
        }
        if (leaveTypesEnabled) {
            error[UserRatesErrors.LEAVE_RATES_EMPTY] = !rateEmpty && isLeaveRatesEmpty(rate.leaveRates)
            error[UserRatesErrors.LEAVE_RATES_INVALID] = !rateEmpty && !isLeaveRatesValid(rate.leaveRates)
        }
        if (Object.values(error).some(value => value === true))
            errors[index] = error

        isValid = isValid && !errors[index]
    })


    if (withWarning && !!errors[updatingRateIndex]) {
        const rateWasEmpty = isRateEmpty(updatingRate, overtimeEnabled, leaveTypesEnabled)

        if (rateWasEmpty && updatingRate.regularRate !== rates[updatingRateIndex].regularRate && errors[updatingRateIndex][UserRatesErrors.REGULAR_RATE_INVALID])
            errors[updatingRateIndex] = {[UserRatesErrors.REGULAR_RATE_INVALID]: true}

        if (rateWasEmpty && updatingRate.overtimeRate !== rates[updatingRateIndex].overtimeRate && errors[updatingRateIndex][UserRatesErrors.OVERTIME_RATE_INVALID])
            errors[updatingRateIndex] = {[UserRatesErrors.OVERTIME_RATE_INVALID]: true}

        if (rateWasEmpty && !_.isEqual(updatingRate.leaveRates, rates[updatingRateIndex].leaveRates) && errors[updatingRateIndex][UserRatesErrors.LEAVE_RATES_INVALID])
            errors[updatingRateIndex] = {[UserRatesErrors.LEAVE_RATES_INVALID]: true}

        errors[updatingRateIndex].showWarning = getWarning(updatingRate, rates[updatingRateIndex], errors[updatingRateIndex])
    }

    return {
        isValid,
        errors
    }
}

const getWarning = (updatingRate, rate, error) => {
    return (error[UserRatesErrors.EFFECTIVE_DATE_EMPTY] || error[ValidationErrors.DUPLICATED_EFFECTIVE_DATE]) && updatingRate.effectiveDate !== rate.effectiveDate ? ShowWarning.EFFECTIVE_DATE_WARNING
           : (error[UserRatesErrors.REGULAR_RATE_EMPTY] || error[UserRatesErrors.REGULAR_RATE_INVALID]) && updatingRate.regularRate !== rate.regularRate ? ShowWarning.REGULAR_RATE_WARNING
           : (error[UserRatesErrors.OVERTIME_RATE_EMPTY] || error[UserRatesErrors.OVERTIME_RATE_INVALID]) && updatingRate.overtimeRate !== rate.overtimeRate ? ShowWarning.OVERTIME_RATE_WARNING
           : (error[UserRatesErrors.LEAVE_RATES_EMPTY] || error[UserRatesErrors.LEAVE_RATES_INVALID]) && !_.isEqual(updatingRate.leaveRates, rate.leaveRates) ? ShowWarning.LEAVE_RATES_WARNING
           : null

}


// WEBPACK FOOTER //
// ./web/js/panels/user/accountSettings/userRates/validationUtils.js